import React from 'react';
import {Grid, Box, Typography} from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PersonIcon from '@mui/icons-material/Person';
import {EntioCard} from 'src/components/ui';
import {brand, semantic} from 'src/theme';

interface PropertyCardProps {
  totalProperties: number;
  totalResidents: number;
}

export default function PropertyCard({totalProperties, totalResidents}: PropertyCardProps) {
  const stats = [
    {
      icon: <ApartmentIcon />,
      label: 'Properties',
      value: totalProperties,
      color: brand[500],
      bgColor: brand[100],
    },
    {
      icon: <PersonIcon />,
      label: 'Residents',
      value: totalResidents,
      color: semantic.warning.main,
      bgColor: semantic.warning.light,
    },
  ];

  return (
    <EntioCard>
      <Box
        sx={{
          p: {xs: 2, sm: 2.5},
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Grid
            container
            spacing={{xs: 1, sm: 2}}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {stats.map((stat, index) => (
              <Grid
                item
                xs={6}
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: 'fit-content',
                  }}
                >
                  <Box
                    sx={{
                      width: {xs: 40, sm: 48},
                      height: {xs: 40, sm: 48},
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      bgcolor: stat.bgColor,
                      color: stat.color,
                      mb: 1,
                      '& svg': {
                        fontSize: {xs: 20, sm: 24},
                      },
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 0.5,
                      fontSize: {xs: '1rem', sm: '1.25rem'},
                      lineHeight: 1.2,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                      fontSize: {xs: '0.75rem', sm: '0.8rem'},
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </EntioCard>
  );
}
